import { render } from "./BillSubmit.vue?vue&type=template&id=40a3dcc4&scoped=true"
import script from "./BillSubmit.vue?vue&type=script&lang=js"
export * from "./BillSubmit.vue?vue&type=script&lang=js"

import "./BillSubmit.vue?vue&type=style&index=0&id=40a3dcc4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a3dcc4"]])

export default __exports__